export const SNMP_STATE_TYPES = {
  simple: 'simple',
  template: 'template',
};

export const SNMP_TEMPLATE_STATE_STATES = {
  info: 'info',
  minor: 'minor',
  major: 'major',
  critical: 'critical',
};
